import http from "../request/https.js"
//例子：比如说现在banner这个接口不需要传token,就在函数中传入第二个参数为true，如果需要传token则不需要传第二个参数
// export function banner(data,){
//     return http.get("banner",data,true)
// }


export function cele_user(data){
    return http.get("cele_user",data)
}
export function expert_create(data){
    return http.post("User_info/expert_create",data)      //专家申请认证
}
export function user_infocreate(data){
    return http.post("user_info/create ",data)      //机构申请认证
}
export function Type_list(data){
    return http.get("article_category/type_list",data)      //行业分类
}
export function patent_index(data){
    return http.get("patent_index",data)      //首页专利列表
}
export function report_index(data){
    return http.get("report_index",data)      //首页研报列表
}
export function userReportSearch(data){
  return http.get("article/userReportSearch",data)      //用户中心咨询数据关联研报
}
export function userPatentSearch(data){
  return http.get("article/userPatentSearch",data)      //用户中心咨询数据关联专利
}
export function userInfos(data){
  return http.get("article/userInfo",data)      //用户是否认证专家||机构状态
}
export function password(data){
  return http.post("user/password",data)      //修改密码
}
export function creditScore(data){
  return http.post("credit_score/index",data)      //账号信用
}
export function creditScoreLogs(data){
  return http.post("credit_score/logs",data)      //信用分记录
}
export function update_img(data){
  return http.post("user/update_img",data)      //修改头像名称
}
export function Infos(data){
  return http.post("user/infos",data)      //获取用户的信息
}
export function img_sign(data){
  return http.post("user/img_sign",data)      //水印
}
export function getInfoxx(data){
  return http.post("user_info/getInfo",data)      //用户是否提交认证
}
export function getFans(data){
  return http.post("relation/web_fans_list",data)      //粉丝管理列表
}
export function RelationSave(data){
  return http.post("relation/save",data)      //粉丝加关注
}
export function RelationDel(data){
  return http.post("relation/del",data)      //粉丝取消关注
}
export function Details(data){
  return http.get("article/update_data",data)      //详情页面接口
}
export function article_top(data) {
    return http.get("comment/top", data); //置顶某条评论
  }
export function Isdetail(data){
  return http.get("article/detail",data)      //资讯详情页面接口
}
export function comment_save(data){
  return http.post("comment/save",data)      //评论接口
}
export function praise(data){
  return http.post("praise/indexs",data)      //点赞接口
}
export function comment_list(data){
  return http.post("comment/commentList",data)      //评论列表
}
export function save_coment(data){
  return http.post("comment/save_coment",data)      //回复评论
}
export function Relation(data){
  return http.post("detail/relation",data)      //详情关注
}
export function praisesave(data){
  return http.post("praise/save",data)      //详情点赞
}

// ------------------
//行业id
export function type_list(data) {
    return http.get("article_category/type_list", data);
  }
  // //用户-文章撤回
  // export function withdraw(data) {
  //   return http.post("withdraw", data);
  // }
  //专利发布
  export function article_patent(data) {
    return http.post("article/patent", data);
  }
  //研报发布
  export function article_report(data) {
    return http.post("article/report", data);
  }
  //专利分类
  export function patent_type(data) {
    return http.get("patent_type", data, true);
  }
  //专利门类
  export function patent_door(data) {
    return http.get("patent_door", data, true);
  }
  
  export function delpatent(data){
    return http.get("user_info/del_patent",data)      //删除专利文章
  }
  export function del_report(data){
    return http.get("user_info/del_report",data)      //删除研报文章
  }
  export function userinfo_delcontent(data){
    return http.get("user_info/del_content",data)      //删除资讯文章
  }
  export function article_userReport(data){
    return http.get("article/userReport",data)      //研报各数据列表
  }
  export function userinfo_withdrawpatent(data) {                   //专利撤销接口
    return http.post("user_info/withdraw_patent", data);
  }
  export function userinfo_withdrawreport(data) {                   //研报撤销接口
    return http.post("user_info/withdraw_report", data);
  }
  export function withdraw(data) {
    return http.post("user_content/withdraw", data);                      //资讯用户文章撤回
  }
  export function article_userAgain(data) {                    //专利和研报和资讯重新上传
    return http.post("article/userAgain", data);
  }
  export function article_updatedata(data){
    return http.get("article/update_data",data)      //修改专利研报数据列表
  }
  export function user_content(data){
    return http.get("user_content/index",data)      //资讯各数据列表
  }
  export function article_userPatent(data){
    return http.get("article/userPatent",data)      //专利各数据列表
  }

  export function Comment_complaintmsg(data) {
      return http.post("Comment/complaint_msg", data); //互动评论
    }
    export function Comment_savecoment(data) {
      return http.post("Comment/save_coment", data); //回复评论
    }
    export function Comment_delcomment(data) {
      return http.post("Comment/del_comment", data); //删除某条评论
    }
    export function Comment_usercommentmsg(data) {
      return http.post("Comment/user_comment_msg", data); //我的评论列表
    }

    export function msg(data) {
        return http.get("article/msg", data); //消息数量
      }
  

export default{

}